import { render } from "./TransManagerStatisticsPage.vue?vue&type=template&id=35a5490b&scoped=true"
import script from "./TransManagerStatisticsPage.vue?vue&type=script&lang=js"
export * from "./TransManagerStatisticsPage.vue?vue&type=script&lang=js"

import "./TransManagerStatisticsPage.vue?vue&type=style&index=0&id=35a5490b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a5490b"]])

export default __exports__